import api, { unwrap } from './client'
import type {
  DashboardAnalytics,
  DashboardAnalyticsSortDirection,
  DashboardAnalyticsSortField,
  DashboardOverview,
} from '@/types/models'

export const dashboardApi = {
  overview(): Promise<DashboardOverview> {
    return unwrap(api.get<{ data: DashboardOverview }>('/dashboard'))
  },
  analytics(
    days: number,
    sort?: DashboardAnalyticsSortField,
    direction?: DashboardAnalyticsSortDirection,
    page?: number,
  ): Promise<DashboardAnalytics> {
    return unwrap(
      // axios omits undefined-valued params from the query string, so
      // omitting sort/direction here preserves the API's task-creation-order
      // default rather than sending an empty sort param.
      api.get<{ data: DashboardAnalytics }>('/dashboard/analytics', { params: { days, sort, direction, page } }),
    )
  },
}
